import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { PipelineSyncPage } from "@/components/data-sources/pipeline-sync-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-sync/pipelines",
  loader: async () => {
    const [historyRes, mappingsRes, columnsRes, fieldsRes] = await Promise.all([
      fetch("/api/hubspot/pipelines/sync-history"),
      fetch("/api/pipelines/mappings"),
      fetch("/api/pipelines/mappable-columns"),
      fetch("/api/pipelines/hubspot-fields"),
    ]);
    const historyData = historyRes.ok ? await historyRes.json() : { results: [] };
    const mappingsData = mappingsRes.ok ? await mappingsRes.json() : { mappings: [] };
    const columnsData = columnsRes.ok ? await columnsRes.json() : { pipeline: [], stage: [] };
    const fieldsData = fieldsRes.ok ? await fieldsRes.json() : { pipeline: [], stage: [] };
    return {
      pipelineSyncHistory: historyData.results ?? [],
      mappings: mappingsData.mappings ?? [],
      mappableColumns: {
        pipeline: columnsData.pipeline ?? [],
        stage: columnsData.stage ?? [],
      },
      hubspotFields: {
        pipeline: fieldsData.pipeline ?? [],
        stage: fieldsData.stage ?? [],
      },
    };
  },
  component: PipelineSyncPageGuard,
});

function PipelineSyncPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <PipelineSyncPage />;
}
